import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BlogItemThree from "../../../Common/Components/BlogItemThree";
import DoneGreen from "../../../../assets/img/icons/tick-white.svg";
import ButtonRightIconGreen from "../../../Common/Components/ButtonRightIconGreen";
import KeywordGenericSearch from "../../Shared/KeywordGenericSearch";
import { resetTestCampaignKeywords, testCampaignKeywords } from "../actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import BlogItemLoaderCustom from "../../../Common/Components/BlogItemLoaderCustom";

type Props = {
  handleOnClickDone?: any;
  keywords?: string[];
  setCampaignKeywords?: any;
};

const KeywordExplorer: React.FC<Props> = ({ handleOnClickDone, keywords, setCampaignKeywords }) => {
  const articles = useSelector((state: RootState) => state.keywordsExplorer.data);
  const loading = useSelector((state: RootState) => state.keywordsExplorer.loading);
  const placeHolder = [1, 2, 3, 4, 5];

  function handleSearch(searchTerms: string[]) {
    if (searchTerms.length > 0) testCampaignKeywords(searchTerms);
    else resetTestCampaignKeywords();
  }

  // useEffect(() => {
  //   if (keywords && keywords?.length > 0) testCampaignKeywords(keywords);
  // }, [keywords]);

  return (
    <Wrapper>
      <div>
        <h2 className="heading pb-1">Keywords explorer</h2>
        <div className="search-wrapper">
          <KeywordGenericSearch
            smartSearchTerms={keywords}
            onSearch={handleSearch}
            setCampaignKeywords={setCampaignKeywords}
          />
        </div>

        {loading === true
          ? placeHolder.map((item) => (
              <div className="mt-3" key={item}>
                <BlogItemLoaderCustom />
              </div>
            ))
          : null}

        <div className="scroll-Wrapper keyword-scroll">
          {keywords && keywords.length > 0 ? (
            articles?.map((articleItem, index) => (
              <BlogItemThree
                key={index}
                class="campaign-keyword-asider"
                addBlog={false}
                articleId={articleItem.id}
                imgUrl={articleItem.image_url}
                title={articleItem.title}
                description={articleItem.description}
                website={articleItem.website}
                publishDate={articleItem.publish_date}
                tags={articleItem.entities}
                entities={articleItem.entities}
                noPreview={true} // adding noPreview props to prevent opening sidebar preview when clicked on it
                inCampaignKeywordExplorer={true}
                hideCompanyOverlay={true}
              />
            ))
          ) : (
            <NoContentText>
              Enter keywords in the search bar above to find relevant content that your audiences will love.
            </NoContentText>
          )}
        </div>

        <div className="footer-wrapper">
          <ButtonRightIconGreen
            icon={DoneGreen}
            label="Done"
            classBtn="done-btn qa-done-btn"
            onClick={handleOnClickDone}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default KeywordExplorer;

const NoContentText = styled.span`
  font-family: "Roboto Slab";
  font-size: 20px;
  color: #424b50;
  /* margin-left: 23%; */
  /* margin-top: 75px; */
  max-width: 620px;
  font-weight: bold;
  line-height: 32px;
  margin: 75px auto;
`;

const Wrapper = styled.div`
  h2 {
    color: #424b50;
    font-size: 30px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 0px;
    display: block;
    font-family: "Roboto Slab", serif;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 21px;
      line-height: 34px;
    }
  }
  .search-bar {
    float: none !important;
  }
  .keyword-explorer {
    font-family: "Roboto Slab", serif;
    font-weight: 800;
    color: #424b50;
    margin-bottom: 13px;
  }
  .footer-wrapper {
    padding: 20px 0px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    width: 100%;
    bottom: 0px;
    right: 24px;
    .done-btn {
      .icon {
        img {
          width: 14px;
        }
      }
    }
  }
  .scroll-Wrapper {
    height: auto;
    overflow-x: hidden;
    &.keyword-scroll {
      margin-top: 24px;
      max-height: calc(100vh - 225px);
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    .content-div {
      .blog-image {
        .banner-left-icons {
          display: none;
        }
      }
      .Blog-menu-icon {
        display: none;
      }
    }
  }
`;
